// Dependencies
require("webstrap/type");
require("grid");

// Copy images
require("!!asset!./img/icn-plan.svg");

// Styles
require("./download-1-1.scss");



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/download-1/view-1/index.js
// module id = 181
// module chunks = 0